import { useState } from "react";
import { deleteAdsSocialPost } from "@/lib/adsAssistantClient";

export function AdsAssistantPostDeleteButton(props: {
  postId: string;
  disabled: boolean;
  onDeleted: () => void;
}) {
  const { postId, disabled, onDeleted } = props;
  const [busy, setBusy] = useState(false);

  return (
    <button
      type="button"
      disabled={disabled || busy}
      className="text-[11px] font-medium text-red-700 hover:underline disabled:opacity-50 dark:text-red-400"
      onClick={() => {
        if (
          !window.confirm(
            "Delete this indexed post from the library? Attached images are removed from Storage. This cannot be undone."
          )
        ) {
          return;
        }
        void (async () => {
          setBusy(true);
          const r = await deleteAdsSocialPost(postId);
          setBusy(false);
          if (!r.ok) {
            window.alert(r.error);
            return;
          }
          onDeleted();
        })();
      }}
    >
      {busy ? "Deleting…" : "Delete post"}
    </button>
  );
}
